import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import jwt_decode from 'jwt-decode'
import Vuex from 'vuex'
import login from './modules/login'
import problemas from './modules/bancoProblemas'
import publicaciones from './modules/publicaciones'
import header from './modules/header'
import proyectos from './modules/proyectos'
import directorio from './modules/directorio'
import vuexCache from 'vuex-cache'

Vue.use(Vuex)


export const store = new Vuex.Store({
  plugins: [vuexCache({timeout: 2 * 60 * 60 * 1000})],
  modules: {
    login,
    problemas,
    publicaciones,
    header,
    proyectos,
    directorio
  },
  state: {
    nombre: 'Maikel Aparicio',
  },
  mutations: {},
  actions: {},
  getters: {}

})




// WEBPACK FOOTER //
// ./src/storage/storage.js